import { Layout, theme } from 'antd';
import Footers from '../components/Footer';
import Headers from '../components/Header';
import Siders from '../components/Sider';
import DownloadPdf from '../components/DownloadPdf';
import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const { Content } = Layout;

const PDFDownload = () => {

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <Layout
            style={{
                minHeight: '100vh',
            }}
        >
            <Siders />
            <Layout>
                <Headers />
                <Content
                    className="site-layout"
                    style={{
                        padding: '0 50px',
                    }}
                >
                    <div
                       style={{
                            padding: 4,
                            minHeight: 380,
                            background: colorBgContainer,
                        }}
                    >
                        <DownloadPdf/>
                    </div>
                </Content>
                <Footers />
            </Layout>
        </Layout>
    );
};

export default PDFDownload;
